import { OpCoData } from '../../models';
import { useCookies } from '../../../../../hooks/useCookies';

import { UseContentSelector } from './UseContentSelector';
import { OpCoListContent } from './OpCoListContent';

export const OpCoContent: UseContentSelector<Array<OpCoData>, OpCoData> = {
  useResultSelector: OpCoListContent.useResultSelector,
  useDataSelector: (data) => {
    const { opco } = useCookies();

    const opcos = OpCoListContent.useDataSelector(data);

    const opcoContent = opcos.find((x) => x.id === opco);

    if (!opcoContent) {
      throw new Error(`No opco data found for opco ID "${opco}"`);
    }

    return opcoContent;
  },
};
